import { Box, Divider } from "@chakra-ui/react";
import SectionSpecialOffer from "../../components/SectionSpecialOffer";
import SectionOffer from "../../components/special-offers/SectionOffer";
import Helmet from "../../containers/Helmet";
import Footer from "../../layout/Footer";
import HeaderV3 from "../../layout/HeaderV3";
import { getHotelBrands, getHotelDetail } from "../../utils/api";
import { safeMarginX } from "../../utils/mediaQuery";
import { IHeader } from "../../utils/types";

export default function SpecialOffersPage({
  header,
  hotelBrands,
}: {
  header: IHeader;
  hotelBrands: any;
}) {
  return (
    <>
      <Helmet title="Special Offers | Parador Hotels & Resorts" />
      <HeaderV3
        headerItem={header}
        isHomepage={false}
        hotelBrands={hotelBrands}
      />
      <SectionSpecialOffer
        isHomepage={false}
        isParador
        hotelName={header.name}
        hotelLoc={header.hotel_location}
        hotelCode={header.hotel_code}
        hotel={header.name}
      />
      <Box w="100%" px={safeMarginX}>
        <Divider
          mt={[3, 5]}
          borderWidth={0.02}
          py={0.02}
          borderColor={`blackAlpha.400`}
          bg={`blackAlpha.400`}
          orientation="horizontal"
        />
      </Box>
      <SectionOffer
        isParador
        isGroupOffer={true}
        hotelCode={header.hotel_code}
      />
      <Box w="100%" px={safeMarginX}>
        <Divider
          mt={[3, 5]}
          borderWidth={0.02}
          py={0.02}
          borderColor={`blackAlpha.400`}
          bg={`blackAlpha.400`}
          orientation="horizontal"
        />
      </Box>
      <SectionOffer
        isParador
        isGroupOffer={false}
        hotelCode={header.hotel_code}
      />
      <Box h={10} />
      <Footer
        loc={header.location_url}
        address={header.location_long}
        email={header.email}
        phone={header.phone}
      />
    </>
  );
}

export async function getStaticProps({ locale }: any) {
  let temp;

  const data: any = await getHotelDetail({
    is_parador: "true",
    cct_status: "publish",
  }).then((r) => r.data[0]);

  temp = await data;

  if (locale == "id") {
    let x = JSON.stringify(data);
    let y = x.replace(/_id/g, "");
    temp = JSON.parse(y);
  } else {
    let x = JSON.stringify(data);
    let y = x.replace(/_en/g, "");
    temp = JSON.parse(y);
  }

  const {
    _ID,
    name,
    location_short,
    location_url,
    hotel_location,
    phone,
    logo_dark,
    logo_light,
    color_primary,
    color_secondary,
    is_parador,
    slug,
    hotel_code,
    location_short_en,
    has_dining,
    has_wedding,
    has_meeting_events,
    location_long,
    location_long_en,
    email,
  } = temp;

  const header: IHeader = {
    email: email,
    instagram: temp.instagram,
    facebook: temp.facebook,
    location_long: location_long ? location_long : location_long_en,
    id: _ID,
    name,
    color_primary,
    color_secondary,
    location: location_short ? location_short : location_short_en,
    location_url,
    hotel_location,
    phone,
    logo_dark,
    logo_light,
    is_parador: is_parador === "true",
    hotel_code: hotel_code == 0 ? null : hotel_code,
    slug,
    has_dining,
    has_wedding,
    has_meeting_events,
  };

  const hotelBrands = await getHotelBrands();

  return {
    props: {
      header,
      hotelBrands,
    },
    revalidate: parseInt(process.env.NEXT_PUBLIC_REVALIDATE_TIME ?? "200", 10), // In seconds
  };
}
